export default __webpack_public_path__ + "static/contact-cover-6b4628bee58ee7d1c4ef842e65ead8b4.png";